import React from 'react';
import ReactDOM from 'react-dom';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import AddOutsourceCard from '../components/AddOutsourceCard';
import ImportOutsourceCard from '../components/ImportOutsourceCard';
import { connect } from 'react-redux';
import OutsourceAssignmentConfirmModal from '../components/OutsourceAssignmentConfirmModal';
import { bindActionCreators } from 'redux';
import * as outsourceActions from '../actions/outsourceActions';
import { CurrentUser } from '../../shared/model/CurrentUser';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class AddOutsourceScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidUpdate(prevProps, prevState) {
        // Detectar que ha cambiado la subcontrata a importar para hacer scroll hasta el formulario.
        if ( prevProps.importOutsource !== this.props.importOutsource ) {
            this.scrollToForm();
        }
    }

    scrollToForm() {
        const formNode = ReactDOM.findDOMNode(this.refs.form);
        if ( formNode ) {
            window.scrollTo(0, formNode.offsetTop);
        }
    }

    render() {
        const { breadcrumbs } = this.state;
        const { outsourceAssignmentDisplay, currentUser } = this.props;

        return (
            <React.Fragment>
                <PsPage title={I18nUtils.tr('TR_MI_NUEVA_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                    {
                        currentUser.hasAPI() ? <ImportOutsourceCard/> : null
                    }
                    <AddOutsourceCard ref="form"/>
                </PsPage>
                <OutsourceAssignmentConfirmModal
                    show={outsourceAssignmentDisplay}
                    onHide={this.handleCloseAssignmentModal}
                    onAccept={this.handleAcceptAssignmentModal}
                />
            </React.Fragment>
        );
    }

    handleCloseAssignmentModal = () => {
        this.props.outsourceActions.setAssignmentModalVisibility(false);
    };

    handleAcceptAssignmentModal = () => {
        const {
            outsourceActions,
            outsourceAssignmentNIF,
            documentSchemaId,
            documentSchemaMonthlyId,
        } = this.props;

        const nextDocumentSchemaId =
            documentSchemaId &&
            documentSchemaId !== -1 &&
            documentSchemaId.length !== 0 ?
                documentSchemaId[0].value :
                undefined;

        const nextDocumentSchemaMonthlyId =
            documentSchemaMonthlyId &&
            documentSchemaMonthlyId !== -1 &&
            documentSchemaMonthlyId.length !== 0 ?
                documentSchemaMonthlyId[0].value :
                undefined;

        outsourceActions.addCompanyAssociation(
            outsourceAssignmentNIF,
            nextDocumentSchemaId,
            nextDocumentSchemaMonthlyId,
        );
    };

}

const mapStateToProps = (state) => {

    let documentSchemaId = null;
    let documentSchemaMonthlyId = null;
    if ( state.form && state.form.OutsourceForm && state.form.OutsourceForm.values ) {
        documentSchemaId = state.form.OutsourceForm.values.document_schema_id;
        documentSchemaMonthlyId = state.form.OutsourceForm.values.document_schema_monthly_id;
    }

    return {
        currentUser: CurrentUser.fromReduxState(state),
        importOutsource: state.importOutsources.importOutsource,
        outsourceAssignmentDisplay: state.outsources.outsourceAssignmentDisplay,
        outsourceAssignmentNIF: state.outsources.outsourceAssignmentNIF,
        documentSchemaId: documentSchemaId,
        documentSchemaMonthlyId: documentSchemaMonthlyId,
    };
};

const mapDispatchToProps = dispatch => ( {
    outsourceActions: bindActionCreators(outsourceActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(AddOutsourceScreen);



// WEBPACK FOOTER //
// ./src/app/outsource/screens/AddOutsourceScreen.jsx